import { getEntityTemplateLang } from '~services/entity-definitions/helpers';
import { createTemporaryEntityId } from '~services/entity-definitions/template-helpers';

export default () => {
  return {
    data: {
      type: 'paragraph--newsfeed',
      id: createTemporaryEntityId(),
      attributes: {
        langcode: getEntityTemplateLang(),
        status: true,
        default_langcode: true,
        field_title: {
          value: null,
          format: 'richt_text',
        },
      },
      relationships: {},
      links: {},
      log: [],
      permissions: {
        update: true,
        create: true,
        delete: true,
      },
    },
  };
};
